import { useEffect, useState,useRef } from "react";
import { RatingReviews } from "./RatingReviews";
import { PricePerUnit } from "./PricePerUnit";
import { Tooltip } from "antd";
import { DeliveryTime } from "./DeliveryTime";
import amazon_fresh from "../../assests/Images/amazon_fresh.png";
import amazon_lucky from "../../assests/Images/amazon_lucky.png";
import amazon_whole_food from "../../assests/Images/amazon_whole_food.png";


export const ProductItemV2 = ({
  product,
  isHighlighted,
  isHighlightedFirst,
  addToCard,
  selectedStore,
  isZerothIndexSame,
  productChips = [],
}) => {
  const {
    image = "",
    title = "",
    vendor="",
    rating = 0,
    reviews = 0,
    price = 0,
    unit = "",
    unit_price = 0,
    capacity_per_pack = 0,
    normalized_unit = "",
    key = "",
    upc = "",
    walmart_item_id="",
    delivery_details = undefined
  } = product || {};
  const [count, setCount] = useState(0);
  const [productKey, setProductKey] = useState("");
  const isSelected = count > 0;
  const [titleTooltipOpen, setTitleTooltipOpen] = useState(false);
    const titleTooltipRef = useRef(null);


    useEffect(() => {
        if (!titleTooltipOpen) return;

        const closeTooltip = () => setTitleTooltipOpen(false);

        // All scroll and gesture events
        window.addEventListener('scroll', closeTooltip, true);
        document.addEventListener('scroll', closeTooltip, true);
        document.addEventListener('wheel', closeTooltip, { passive: true });
        document.addEventListener('touchmove', closeTooltip, { passive: true });
        window.addEventListener('resize', closeTooltip);

        // Find and listen to scrollable parents
        let parent = titleTooltipRef.current?.parentElement;
        const scrollableParents = [];

        while (parent) {
            const style = window.getComputedStyle(parent);
            if (
                style.overflow === 'auto' ||
                style.overflow === 'scroll' ||
                style.overflowX === 'auto' ||
                style.overflowX === 'scroll' ||
                style.overflowY === 'auto' ||
                style.overflowY === 'scroll'
            ) {
                scrollableParents.push(parent);
                parent.addEventListener('scroll', closeTooltip, { passive: true });
            }
            parent = parent.parentElement;
        }

        return () => {
            window.removeEventListener('scroll', closeTooltip, true);
            document.removeEventListener('scroll', closeTooltip, true);
            document.removeEventListener('wheel', closeTooltip);
            document.removeEventListener('touchmove', closeTooltip);
            window.removeEventListener('resize', closeTooltip);

            scrollableParents.forEach(p => {
                p.removeEventListener('scroll', closeTooltip);
            });
        };
    }, [titleTooltipOpen]);

  useEffect(() => {
    setCount(0);
  }, [selectedStore]);

  useEffect(() => {
    addToCard({
      productKey: productKey,
      quantity: count,
      price: price,
      productTitle: title,
      unitPrice: unit_price,
      upc: upc,
      walmart_item_id:walmart_item_id,
      store: product.store || "Amazon",
      vendor:vendor
    });
  }, [count, productKey]);

  const decrease = (key) => {
    if (count > 0) {
      setCount((prev) => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
      setProductKey(key);
    }
  };

  const increase = (key) => {
    if (count < 100) {
      setCount((prev) => prev + 1);
      setProductKey(key);
    }
  };

  const renderChips = () => {
    if (!productChips || productChips.length === 0) return null;

    // Define chip configurations
    const chipConfig = {
      cheapest: {
        label: 'Budget',
        className: 'bg-black text-white'
      },
      highest: {
        label: 'Top Rated',
        className: 'bg-black text-white' // Different color to distinguish
      },
      best: {
        label: 'Best Value',
        className: 'bg-black text-white'
      }
    };

    // Sort chips in desired order: cheapest → highest → best
    const chipOrder = ['cheapest', 'highest', 'best'];
    const sortedChips = productChips.sort((a, b) => {
      return chipOrder.indexOf(a) - chipOrder.indexOf(b);
    });

    return (
      <div className="absolute -top-8 sm:-top-9 left-1/2 -translate-x-1/2 flex gap-2 flex-wrap justify-center max-w-full w-max px-2">
        {sortedChips.map((chipType) => {
          const config = chipConfig[chipType];
          if (!config) return null;

          return (
            <div
              key={chipType}
              className={`inline-flex items-center justify-center gap-2 px-2 py-1 sm:px-3 sm:py-2 rounded-full font-semibold text-xs leading-none ${config.className}`}
            >
              {config.label}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div
      className={`
        relative rounded-[12px]
        mb-[5px] ml-[5px] mr-[5px]
        mt-[35px] flex flex-col
        w-[220px]
        sm:w-[260px]
        md:w-[240px]
        flex-shrink-0
        border-2
        shadow-[0_2px_8px_rgba(0,0,0,0.12)]
        ${isSelected ? "border-teal-400" : "border-transparent"}
      `}
    >


      {/* {(isHighlighted && !isZerothIndexSame) && (
        <div className="absolute rounded-3xl left-1/3 -top-9">
          <div className="inline-flex items-center justify-center gap-2 px-2 py-1 sm:px-3 sm:py-2 rounded-full bg-black text-white font-semibold text-xs leading-none ">
            Cheapest
          </div>
        </div>
      )}

      {(isHighlighted && isZerothIndexSame) && (
        <div className="absolute rounded-3xl left-6 -top-8 sm:-top-9 sm:left-6">
          <div className="flex gap-2">
            <div className="inline-flex items-center justify-center gap-2 px-2 py-1 sm:px-3 sm:py-2 rounded-full bg-black text-white font-semibold text-xs leading-none ">
              Cheapest
            </div>
            <div className="inline-flex items-center justify-center gap-2 px-2 py-1 sm:px-3 sm:py-2 rounded-full bg-black text-white font-semibold text-xs leading-none ">
              Best Value
            </div>
          </div>
        </div>
      )}

      {(isHighlightedFirst && !isZerothIndexSame) && (
        <div className="absolute rounded-3xl left-1/3 -top-8 sm:-top-9">
          <div className="inline-flex items-center justify-center gap-2 px-2 py-1 sm:px-3 sm:py-2 rounded-full bg-black text-white font-semibold text-xs leading-none ">
            Best Value
          </div>
        </div>
      )} */}

      {renderChips()}

      <div className="absolute rounded-3xl right-1 top-2">
        {count === 0 ? (
          <button
            className="bg-[#0AE2CD] text-black font-semibold text-[16px] px-4 py-3 rounded-[50px] shadow-md"
            onClick={() => {
              increase(key);
            }}
          >
            + Add
          </button>
        ) : (
          <div className="flex items-center  bg-[#0AE2CD] rounded-[50px] min-w-[60px] justify-between px-2 py-1">
            <button
              onClick={() => {
                decrease(key);
              }}
              className="px-3 text-[22px] text-black font-medium"
            >
              −
            </button>

            <span className="w-6 text-center text-[20px] font-medium text-gray-900">
              {count}
            </span>

            <button
              onClick={() => {
                increase(key);
              }}
              className="px-3 text-[22px] font-medium text-black"
            >
              +
            </button>
          </div>
        )}
      </div>

      <div className={`px-[10px] pt-2 pb-2`}>
        <img
          src={image}
          alt="Product"
          className="w-full h-[150px] object-contain object-center rounded-lg"
        />

        {/* Product Title */}
        <Tooltip title={title} placement="top" open={titleTooltipOpen}
                onOpenChange={setTitleTooltipOpen}
                trigger="click"
                destroyTooltipOnHide={true}>
          <h3 className="mt-3 text-xs sm:text-sm text-gray-800 line-clamp-3 leading-snug min-h-[3.6em] sm:min-h-[4.2em]">
            {title}
          </h3>
        </Tooltip>

        <span className={`bg-white`}>
          {vendor?
          <img src={vendor==="whole_foods" ? amazon_whole_food : vendor ==="amazon_fresh"? amazon_fresh : vendor ==="lucky" ? amazon_lucky :"" } width={vendor==="whole_foods" ? "40%" : vendor ==="amazon_fresh"? "12%" : vendor ==="lucky" ? "20%" :"15%" } height={"10px"}/>
          : <div className="h-[10px]"></div>}
        </span>

        {/* Rating & Weight */}
        <div className="flex items-center justify-between mt-2 whitespace-nowrap">
          {rating > 0 ? (
            <RatingReviews rating={rating} reviews={reviews} />
          ) : (
            <div className="h-5"></div>
          )}

          {/* Weight */}
          <div className="bg-black text-white text-[10px] sm:text-xs px-1.5 py-0.5 rounded-[6px] shrink-0 gap-1">
            {`${capacity_per_pack} ${normalized_unit}`}
          </div>
        </div>

        <PricePerUnit unit={normalized_unit} unitPrice={unit_price} />

        <div className="flex items-center justify-between mt-3">
          {/* Price */}
          <p className="text-base font-bold text-gray-900 mr-1">
            ${price.toFixed(2)}
          </p>
          <DeliveryTime delivery_details={delivery_details}/>
        </div>
      </div>
    </div>
  );
};
